var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104.12 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "folder-category") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8,0V33.06H36.47v8H8v63.61H36v8H0V0ZM45.31,92.07l3.83,28.87a2,2,0,0,0,1.8,1.94H97.37c1.07,0,1.67-1,1.8-2l5-28.81Zm2.37-8.24-2.13,4.73h58.39l-2.15-4.74h-26a1.55,1.55,0,0,1-1.56-1.56V78.55H52v3.73a1.54,1.54,0,0,1-1.55,1.55ZM45.31,28.4l3.83,28.86a2,2,0,0,0,1.8,1.94H97.37c1.07,0,1.67-1,1.8-2l5-28.82Zm2.37-8.24-2.13,4.72h58.39l-2.15-4.73h-26a1.56,1.56,0,0,1-1.56-1.56V14.88H52V18.6a1.55,1.55,0,0,1-1.55,1.56Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolders);
export default __webpack_public_path__ + "static/media/folders.4a33c747d85d2af48befb9a01aea4627.svg";
export { ForwardRef as ReactComponent };